import { BooleanInput } from '@angular/cdk/coercion';
import {
  Component,
  booleanAttribute,
  computed,
  input,
  output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { DatePipe } from '../../pipes/date.pipe';
import { conditionalColumns } from '../../utilities/table.util';
import { Button } from '../button/button.component';
import { StatusBadge } from '../status-badge/status-badge.component';
import { Tag } from '../tag/tag.component';

@Component({
  selector: 'procure-tasks-table',
  templateUrl: './tasks-table.component.html',
  styleUrl: './tasks-table.component.scss',
  imports: [
    MatTable,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderCellDef,
    MatCell,
    MatRow,
    MatCellDef,
    MatColumnDef,
    MatNoDataRow,
    MatRowDef,
    MatHeaderRowDef,
    DatePipe,
    StatusBadge,
    MatIcon,
    Button,
    Tag,
  ],
})
export class TasksTable<T> {
  readonly showMode = input.required<boolean, BooleanInput>({
    transform: booleanAttribute,
  });

  readonly dataSource = input.required<MatTableDataSource<T>>();

  readonly edit = output<number>();
  readonly remove = output<number>();

  protected readonly displayedColumns = computed(() =>
    conditionalColumns({
      task: true,
      responsibleUsers: true,
      dueDate: true,
      status: true,
      actions: !this.showMode(),
    }),
  );
}
